import position from '@/api/position'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  levels: [],
  parent_positions: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_LEVELS(state, data) {
    state.levels = data
  },
  SET_PARENT_POSITIONS(state, data) {
    state.parent_positions = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return position.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return position.store(data)
  },

  async find(context, id) {
    return await position.find(id)
  },

  update(context, data) {
    return position.update(data)
  },

  delete(context, data) {
    return position.destroy(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.levels.length > 0) {
      let response = await position.positionLevel()
      context.commit('SET_LEVELS', response)
    }
    if (!context.state.parent_positions.length > 0) {
      let response = await position.parentPosition()
      context.commit('SET_PARENT_POSITIONS', response)
    }
  },

  async getNewParentPostion(context) {
    let response = await position.parentPosition()
    context.commit('SET_PARENT_POSITIONS', response)
  }
}
